<template>
  <Loading v-if="componentLoading" :style="style" />
  <view v-else class="pft-article-style-1-component" :style="style" flex="dir:left">
    <template v-if="list.length > 0">
      <view v-for="(item, index) of list" class="article-item" :key="index" :style="getTabStyle(index)" flex="dir:top">
        <view :class="{ 'article-title': true }" flex="dir:left main:justify cross:center">
          <view flex="dir:left cross:center">
            <view class="text-title" :style="titleStyle">{{ item[titleKey] }}</view>
          </view>
        </view>
        <div class="notice-contain" :style="contentStyle" :ref="addRef" v-html="item[contentKey]"></div>
      </view>
    </template>
    <template v-else>
      <view class="empty-placeholder">暂无数据</view>
    </template>
  </view>
</template>
<!-- TODO 待完善 -->
<script lang="ts" setup>
import { ref, nextTick } from "vue"
import Loading from "@p-v/packages/Loading.vue"
import sleep from "@p-v/utils/sleep"
interface DataTextProps {
  style?: { [key: string]: string | number }
  titleStyle?: { [key: string]: string | number }
  contentStyle?: { [key: string]: string | number }
  titleKey: string
  contentKey: string
  duration?: number
  contentDuration?: number
}

const props = withDefaults(defineProps<DataTextProps>(), {
  style: () => ({ width: "100%", height: "100%" }),
  titleStyle: () => ({}),
  contentStyle: () => ({}),
  titleKey: () => "",
  contentKey: () => "",
  duration: () => 5000,
  contentDuration: () => 50,
})
// 获取插槽内容

const componentLoading = ref<boolean>(true)

let activeIndex = ref(0)
let contentRefs = ref<HTMLBaseElement[]>([])

const addRef = (ref: HTMLBaseElement) => {
  // console.log(ref)
  contentRefs.value.push(ref)
}

let slotTabStyle = ref({})
let list = ref<{ [key: string]: string | number }[]>([])

const changeTab = async (key: number) => {
  if (activeIndex.value === list.value.length - 1) {
    activeIndex.value = 0
  } else {
    activeIndex.value += key
  }

  slotTabStyle.value = {
    transform: `translateX(${-activeIndex.value * 100}%)`,
  }
  const curContentDom = contentRefs.value[activeIndex.value]
  const curContentDomHeight = curContentDom.offsetHeight
  const scrollTop = curContentDom.scrollTop
  const curContentDomScrollHeight = curContentDom.scrollHeight

  const offsetHeight = curContentDomScrollHeight - curContentDomHeight
  if (offsetHeight < 0) {
    setTimeout(() => {
      changeTab(1)
    }, props.duration)
  } else {
    await sleep(1000)
    for (let i = scrollTop; i < offsetHeight; i++) {
      curContentDom.scrollTop = i
      await sleep(props.contentDuration)
    }
    setTimeout(
      () => {
        curContentDom.scrollTop = 0
        changeTab(1)
      },
      Math.max(props.duration - offsetHeight * props.contentDuration, 1000),
    )
  }

  // console.log("curContentDom", curContentDom, curContentDom.offsetHeight, curContentDom.scrollTop, curContentDom.scrollHeight)
}

const getTabStyle = (index: number) => {
  return {
    opacity: index === activeIndex.value ? 1 : 0,
    transform: `translateX(${-activeIndex.value * 100}%)`,
  }
}

const loading = () => {
  componentLoading.value = true
}

const setData = (data: { list: { [key: string]: string | number }[] }) => {
  list.value = data.list
  componentLoading.value = false
  nextTick(() => {
    changeTab(0)
  })
}
defineExpose({ setData, loading })

// console.log(slots, tabsPageKeys)
</script>
<style lang="scss">
.pft-article-style-1-component {
  padding: 16px;
  box-sizing: border-box;
  overflow: hidden;
  .article-item {
    opacity: 0;
    transition: all 1s;
    width: 100%;
    flex-shrink: 0;
  }
  .article-title {
    margin-bottom: 7px;
    position: relative;
    &.tabs {
      margin-bottom: 20px;
    }
    .title-icon {
      display: flex;
      img {
        width: 16px;
        height: 16px;
        margin-right: 6px;
      }
    }
    .text-title {
      font-family:
        Segoe UI,
        Segoe UI;
      font-weight: bold;
      font-size: 16px;
      line-height: 19px;
      text-align: left;
      color: #cbe5fe;
    }
    .tabs {
      border-radius: 20px;
      border: 2px solid rgba(255, 255, 255, 0.2);
      height: 32px;
      line-height: normal;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      color: #fff;
      .tab {
        padding: 4px 16px;
        font-size: 14px;
        cursor: pointer;
        &.active {
          background: #2b97f7;
          border-radius: 32px;
        }
      }
    }
  }
  .notice-contain {
    // background: rgba(29, 45, 71, 0.75);
    // border-radius: 12px 12px 12px 12px;
    // padding: 16px;
    overflow-y: scroll;
    // 隐藏滚动条
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
.empty-placeholder {
  color: #fff;
  font-size: 16px;
  text-align: center;
  display: block;
  margin: auto;
}
</style>
